<template>
  <div
    ref="contentBoth"
    @mouseleave="childHoverLeave(false, -1, -1)"
    v-if="!isInMobileHeader"
    class="basic_navbar"
  >
    <div class="tooptipPart module_edit_btn">
      <div class="controlContent lineControl" @click.stop="showContentPop">
        <p class="lineWords">{{$t('components_my_navbar_index_2369')}}</p>
      </div>
      <my_edit_btn :module="module"></my_edit_btn>
      <!--新增栏目暂时隐藏掉，没有写点击事件-->
      <add_button :title="$t('widgets_basic_navbar_index_2659')" v-if="false"></add_button>
      <my_moduleShow_btn
        radioName="headerNavRadio"
        :title="$t('widgets_basic_navbar_index_2660')"
      ></my_moduleShow_btn>
    </div>
    <div
      class="barLine"
      :style="{
        height:
          pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val]
            .height + 'px',
      }"
    >
      <img
        id="baseImg"
        v-if="pc_widgets_infor.showLogo === 'true'"
        class="firstImg"
        @load="getImgWidth"
        :src="
          module.data.listArr.logoUrl
            ? module.data.listArr.logoUrl
            : '/static/image/logo.jpg'
        "
      />
      <div class="btn_part">
        <div
          v-show="leftChange != 0"
          class="leftBtn iconfont icon-jiantouzuo"
          :style="{
            lineHeight:pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val].height + 'px',
            color: $store.state.myRender.common.theme_color
          }"
          @click.stop="changeSize(1)"
        ></div>
        <!-- {{leftChange,leftChangeMax}} -->
        <template v-if="pc_widgets_infor.showLogo === 'false' && pc_widgets_infor.styleType === 'type_13'">
          <div class="rightBtn iconfont icon-gengduo1"
               v-show="leftChange != leftChangeMax && leftChangeMax < 0"
               :style="{
                lineHeight:pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val].height + 'px',
                color: $store.state.myRender.common.theme_color
              }"
               @click.stop="openDropDownMenu">
          </div>
        </template>
        <template v-else>
          <div
            v-show="leftChange != leftChangeMax && leftChangeMax < 0"
            class="rightBtn iconfont icon-jiantouyou"
            :style="{
                lineHeight:pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val].height + 'px',
                color: $store.state.myRender.common.theme_color
              }"
            @click.stop="changeSize(-1)"
          ></div>
        </template>
      </div>
      <div class="navContent hiddenContent" style="opacity: 0">
        <div
          class="navPart"
          :style="{
            height:
              pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val]
                .height + 'px',
            textAlign:pc_widgets_infor.navTextAlign,
          }"
        >
          <ul class="navLine clearfix" style="overflow: hidden">
            <template v-for="(item, index) in listData">
              <span class="itemNav" :key="index">
                <b
                  v-if="
                    item.type &&
                    item.type == 'Logoimg' &&
                    pc_widgets_infor.showLogo === 'true'
                  "
                  class="changeImg el-icon-edit"
                ></b>
                <li
                  class="pageLine"
                  :style="[
                    {
                      overflow: 'hidden',
                      height:
                        pc_widgets_infor.navheight[
                          pc_widgets_infor.navheight.radio_val
                        ].height + 'px',
                      lineHeight:
                        pc_widgets_infor.navheight[
                          pc_widgets_infor.navheight.radio_val
                        ].height + 'px',
                      marginRight:
                        pc_widgets_infor.marginRight[
                          pc_widgets_infor.marginRight.radio_val
                        ].value + 'px',
                      color:
                        pc_widgets_infor.navfont[
                          pc_widgets_infor.navfont.radio_val
                        ].fontColor,
                      borderRadius:
                        pc_widgets_infor.borderRadius[
                          pc_widgets_infor.borderRadius.radio_val
                        ].value + 'px',
                    },
                    base_background,
                    border,
                  ]"
                >
                  <div class="pagePart">
                    <span
                      class="pageLink"
                      v-if="!item.type || (item.type && item.type !== 'Logoimg')"
                      :class="{
                        navNoClick:
                          pc_widgets_infor.navClick === 'false' &&
                          item.children.length > 0,
                      }"
                      :style="[
                        {
                          textAlign:
                            pc_widgets_infor.navTextAlign,
                          lineHeight:
                            pc_widgets_infor.navheight[
                              pc_widgets_infor.navheight.radio_val
                            ].height + 'px',
                          display: 'inline-block',
                          webkitBackgroundClip: 'text',
                        },
                        fontStyle,
                      ]"
                    >
                      {{ item.name }}
                    </span>
                    <span
                      class="logoPart"
                      v-if="
                        item.type &&
                        item.type == 'Logoimg' &&
                        pc_widgets_infor.showLogo === 'true'
                      "
                    >
                      <img
                        :src="
                          module.data.listArr.logoUrl
                            ? module.data.listArr.logoUrl
                            : '/static/image/logo.jpg'
                        "
                        :style="{
                          height:
                            pc_widgets_infor.navheight[
                              pc_widgets_infor.navheight.radio_val
                            ].height + 'px',
                          minWidth:
                            pc_widgets_infor.navheight[
                              pc_widgets_infor.navheight.radio_val
                            ].width + 'px',
                        }"
                      />
                    </span>
                  </div>
                </li>
                <li
                  class="line"
                  :style="{
                    display:
                      pc_widgets_infor.splitLine.radio_val !== 'hidden'
                        ? 'inline-block'
                        : 'none',
                    right:
                      pc_widgets_infor.marginRight[
                        pc_widgets_infor.marginRight.radio_val
                      ].value /
                        2 +
                      'px',
                    lineHeight:
                      pc_widgets_infor.splitLine.radio_val !== 'hidden'
                        ? pc_widgets_infor.navheight[
                            pc_widgets_infor.navheight.radio_val
                          ].height + 'px'
                        : 0,
                    height:
                      pc_widgets_infor.splitLine.radio_val !== 'hidden'
                        ? pc_widgets_infor.navfont[
                            pc_widgets_infor.navfont.radio_val
                          ].fontSize + 'px'
                        : 0,
                    transform:
                      pc_widgets_infor.splitLine.radio_val !== 'hidden'
                        ? 'rotate(' +
                          pc_widgets_infor.splitLine[
                            pc_widgets_infor.splitLine.radio_val
                          ].rotate +
                          'deg)'
                        : '',
                    background:
                      pc_widgets_infor.splitLine.radio_val !== 'hidden'
                        ? pc_widgets_infor.splitLine[
                            pc_widgets_infor.splitLine.radio_val
                          ].pattern == 'linear_gradient'
                          ? 'linear-gradient(' +
                            pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].linear_gradient.deg +
                            'deg,' +
                            pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].linear_gradient.start_color +
                            pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].linear_gradient.start_pointer +
                            '%,' +
                            pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].linear_gradient.end_color +
                            pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].linear_gradient.end_pointer +
                            '%)'
                          : pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].baseColor
                        : '',
                  }"
                ></li>
                <div
                  class="navchildlist"
                  :style="{
                    maxHeight: '40px',
                    overflow: 'hidden',
                  }"
                >
                  <ul class="navchildPart">
                    <li
                      class="navchildLine"
                      v-for="(e, i) in item.children"
                      :key="i"
                    >
                      <div
                        class="navchildData"
                        :style="[
                          {
                            textAlign: pc_widgets_infor.navChildtextAlign,
                          },
                          ch_background,
                        ]"
                      >
                        <span
                          class="navchildLink"
                          :style="[
                            {
                              textAlign: pc_widgets_infor.navChildtextAlign,
                            },
                            ch_fontStyle,
                          ]"
                        >
                          {{ e.name }}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </span>
            </template>
          </ul>
        </div>
      </div>
      <div
        class="navContent hasContent"
        @mouseleave="changeData(activeIndex)"
        :class="pc_widgets_infor.styleType"
      >
        <div
          class="navPart"
          :style="{
            height:
              pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val]
                .height + 'px',
            textAlign:pc_widgets_infor.navTextAlign,
          }"
        >
          <div class="hasWidth">
            <ul class="navLine clearfix">
              <template v-for="(item, index) in listData">
                <span
                  class="itemNav"
                  :key="index"
                  :class="
                    item.type &&
                    item.type == 'Logoimg' &&
                    pc_widgets_infor.showLogo === 'true'
                      ? 'noBorderRa'
                      : ''
                  "
                >
                  <b
                    v-if="
                      item.type &&
                      item.type == 'Logoimg' &&
                      pc_widgets_infor.showLogo === 'true'
                    "
                    class="changeImg el-icon-edit"
                  >
                    <my_img_cover
                      :firstModel.sync="module.data.listArr.logoUrl"
                      :fileType="1"
                    ></my_img_cover>
                  </b>
                  <li
                    class="pageLine"
                    @mouseenter="
                      (e) => {
                        changeData(index);
                        hoverChange(e, true);
                      }
                    "
                    @mouseleave="
                      (e) => {
                        changeData(index);
                        hoverChange(e, false);
                      }
                    "
                    @click.stop="toPage(item, pc_widgets_infor.navClick)"
                    :style="[
                      {
                        overflow: 'hidden',
                        width: !item.type || (item.type && item.type !== 'Logoimg') ? 'auto' : pcLogoWidth + 'px',
                        height:
                          pc_widgets_infor.navheight[
                            pc_widgets_infor.navheight.radio_val
                          ].height + 'px',
                        lineHeight:
                          pc_widgets_infor.navheight[
                            pc_widgets_infor.navheight.radio_val
                          ].height + 'px',
                        borderRadius:
                          item.type && item.type == 'Logoimg'
                            ? '0px'
                            : pc_widgets_infor.borderRadius[
                                pc_widgets_infor.borderRadius.radio_val
                              ].value + 'px',
                        marginRight:
                          pc_widgets_infor.marginRight[
                            pc_widgets_infor.marginRight.radio_val
                          ].value + 'px',
                        color:
                          pc_widgets_infor.navfont[
                            pc_widgets_infor.navfont.radio_val
                          ].fontColor,
                        '--baseSe_background_color': pc_widgets_infor.navSeBackground.radio_val !== 'hidden' ? 
                          pc_widgets_infor.navSeBackground[
                            pc_widgets_infor.navSeBackground.radio_val
                          ].color : '',
                        '--borderRadius': pc_widgets_infor.borderRadius[
                          pc_widgets_infor.borderRadius.radio_val
                        ].value + 'px',
                      },
                      !item.type || (item.type && item.type !== 'Logoimg')
                        ? activeIndex == index ||
                          routePath === '/' + item.theme_name
                          ? baseSe_background
                          : base_background
                        : {},
                      !item.type || (item.type && item.type !== 'Logoimg')
                        ? activeIndex == index ||
                          routePath === '/' + item.theme_name
                          ? seborder
                          : border
                        : {},
                    ]"
                  >
                    <div
                      class="pagePart"
                      :class="
                        pc_widgets_infor.bilingualSet.radio_val == 'custom'
                          ? `bilingualSetWarp bilingualSetWarp_${pc_widgets_infor.bilingualSet.custom.type}`
                          : ''
                      "
                    >
                      <span
                        v-if="
                          pc_widgets_infor.bilingualSet.radio_val == 'custom' &&
                          pc_widgets_infor.bilingualSet.custom.type == 2
                        "
                        class="other_name"
                        :style="[
                          {
                            textAlign:
                              pc_widgets_infor.navTextAlign,
                            lineHeight:
                              pc_widgets_infor.navheight[
                                pc_widgets_infor.navheight.radio_val
                              ].height /
                                2 - pc_widgets_infor.border[pc_widgets_infor.border.radio_val].borderWidth +
                              'px',
                          },
                          activeIndex == index ||
                          routePath === '/' + item.theme_name
                            ? fontSeStyle
                            : fontStyle,
                        ]"
                      >{{
                          item.other_name &&
                          item.other_name !== null &&
                          item.other_name !== ""
                            ? item.other_name
                            : item.name
                        }}</span
                      >
                      <span
                        class="pageLink nav_item_name"
                        v-if="item.type !== 'Logoimg'"
                        :class="{
                          navNoClick:
                            pc_widgets_infor.navClick === 'false' &&
                            item.children.length > 0,
                        }"
                        :style="[
                          {
                            textAlign:
                              pc_widgets_infor.navTextAlign,
                            lineHeight:
                              pc_widgets_infor.bilingualSet.radio_val ==
                                'custom' &&
                              pc_widgets_infor.bilingualSet.custom.type !== 1
                                ? (pc_widgets_infor.navheight[
                                    pc_widgets_infor.navheight.radio_val
                                  ].height /
                                    2) - pc_widgets_infor.border[pc_widgets_infor.border.radio_val].borderWidth +
                                  'px'
                                : pc_widgets_infor.navheight[
                                    pc_widgets_infor.navheight.radio_val
                                  ].height - pc_widgets_infor.border[pc_widgets_infor.border.radio_val].borderWidth*2 + 'px',
                            display:
                              pc_widgets_infor.bilingualSet.radio_val ==
                              'custom'
                                ? 'block'
                                : 'inline-block',
                            height:
                              pc_widgets_infor.bilingualSet.radio_val ==
                              'custom'
                                ? 'auto'
                                : '100%',
                            webkitBackgroundClip: 'text',
                          },
                          activeIndex == index ||
                          routePath === '/' + item.theme_name
                            ? fontSeStyle
                            : fontStyle,
                        ]"
                      >
                        {{ item.name }}  <i v-if="item.children && item.children.length > 0 && pc_widgets_infor.showArrow && pc_widgets_infor.showArrow === 'true'" class="el-icon-arrow-down is-down"></i>
                      </span>
                      <span
                        v-if="
                          pc_widgets_infor.bilingualSet.radio_val == 'custom' &&
                          pc_widgets_infor.bilingualSet.custom.type == 0
                        "
                        class="other_name"
                        :style="[
                          {
                            textAlign:
                              pc_widgets_infor.navTextAlign,
                            lineHeight:
                              pc_widgets_infor.navheight[
                                pc_widgets_infor.navheight.radio_val
                              ].height /
                                2 - pc_widgets_infor.border[pc_widgets_infor.border.radio_val].borderWidth +
                              'px',
                          },
                          activeIndex == index ||
                          routePath === '/' + item.theme_name
                            ? fontSeStyle
                            : fontStyle,
                        ]"
                      >{{
                          item.other_name &&
                          item.other_name !== null &&
                          item.other_name !== ""
                            ? item.other_name
                            : item.name
                        }}</span
                      >
                      <span
                        v-if="
                          pc_widgets_infor.bilingualSet.radio_val == 'custom' &&
                          pc_widgets_infor.bilingualSet.custom.type == 1
                        "
                        class="other_name"
                        :style="[
                          {
                            textAlign:
                              pc_widgets_infor.navTextAlign,
                            display: 'none',
                            lineHeight:
                              pc_widgets_infor.navheight[
                                pc_widgets_infor.navheight.radio_val
                              ].height - pc_widgets_infor.border[pc_widgets_infor.border.radio_val].borderWidth * 2 + 'px',
                          },
                          activeIndex == index ||
                          routePath === '/' + item.theme_name
                            ? fontSeStyle
                            : fontStyle,
                        ]"
                      >{{
                          item.other_name &&
                          item.other_name !== null &&
                          item.other_name !== ""
                            ? item.other_name
                            : item.name
                        }}</span
                      >
                      <span
                        class="logoPart"
                        v-if="
                          item.type &&
                          item.type == 'Logoimg' &&
                          pc_widgets_infor.showLogo === 'true'
                        "
                      >
                        <img
                          :src="
                            module.data.listArr.logoUrl
                              ? module.data.listArr.logoUrl
                              : '/static/image/logo.jpg'
                          "
                          :style="{
                            height:
                              pc_widgets_infor.navheight[
                                pc_widgets_infor.navheight.radio_val
                              ].height + 'px',
                          }"
                        />
                      </span>
                    </div>
                  </li>
                  <li
                    class="line"
                    v-if="index != listData.length - 1"
                    :style="{
                      display:
                        pc_widgets_infor.splitLine.radio_val !== 'hidden'
                          ? 'inline-block'
                          : 'none',
                      right:
                        pc_widgets_infor.marginRight[
                          pc_widgets_infor.marginRight.radio_val
                        ].value /
                          2 +
                        'px',
                      lineHeight:
                        pc_widgets_infor.splitLine.radio_val !== 'hidden'
                          ? pc_widgets_infor.navheight[
                              pc_widgets_infor.navheight.radio_val
                            ].height + 'px'
                          : 0,
                      height:
                        pc_widgets_infor.splitLine.radio_val !== 'hidden'
                          ? pc_widgets_infor.navfont[
                              pc_widgets_infor.navfont.radio_val
                            ].fontSize + 'px'
                          : 0,
                      transform:
                        pc_widgets_infor.splitLine.radio_val !== 'hidden'
                          ? 'rotate(' +
                            pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].rotate +
                            'deg)'
                          : '',
                      background:
                        pc_widgets_infor.splitLine.radio_val !== 'hidden'
                          ? pc_widgets_infor.splitLine[
                              pc_widgets_infor.splitLine.radio_val
                            ].pattern == 'linear_gradient'
                            ? 'linear-gradient(' +
                              pc_widgets_infor.splitLine[
                                pc_widgets_infor.splitLine.radio_val
                              ].linear_gradient.deg +
                              'deg,' +
                              pc_widgets_infor.splitLine[
                                pc_widgets_infor.splitLine.radio_val
                              ].linear_gradient.start_color +
                              pc_widgets_infor.splitLine[
                                pc_widgets_infor.splitLine.radio_val
                              ].linear_gradient.start_pointer +
                              '%,' +
                              pc_widgets_infor.splitLine[
                                pc_widgets_infor.splitLine.radio_val
                              ].linear_gradient.end_color +
                              pc_widgets_infor.splitLine[
                                pc_widgets_infor.splitLine.radio_val
                              ].linear_gradient.end_pointer +
                              '%)'
                            : pc_widgets_infor.splitLine[
                                pc_widgets_infor.splitLine.radio_val
                              ].baseColor
                          : '',
                    }"
                  ></li>
                </span>
              </template>
            </ul>
          </div>
        </div>
        <div class="navbar_dropdown_panel" v-if="dropDownMenuShow" :style="{
          top : pc_widgets_infor.navheight[pc_widgets_infor.navheight.radio_val].height/2 + 25 + 'px'
        }">
          <div class="dropdown_panel_triangle" :style="level_1_background"></div>
          <ul class="navbar_dropdown_content" v-if="rightListData.length > 0">
            <li class="navbar_dropdown_item"
                :style="[{
              '--level_1_bgckgroundColor': pc_widgets_infor.navSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].type === 'color' ? pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].color : 'transparent',
              '--level_1_backgroundImage': pc_widgets_infor.navSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].type !== 'color' && pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].img ? `url(${pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].img})` : 'none',
              '--level_1_backgroundSize': pc_widgets_infor.navSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].background_size : 'unset',
              '--level_1_backgroundRepeat': pc_widgets_infor.navSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].background_repeat : 'unset',
              '--level_1_backgroundPosition': pc_widgets_infor.navSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navSeBackground[pc_widgets_infor.navSeBackground.radio_val].background_position : 'unset'
            },level_1_background]"
                v-for="(item, index) in rightListData"
                :key="index">
              <div class="navPage">
                <a
                  class="navPageLink"
                  :style="[fontStyleNew_level_1,{
                      '--level_1_SeColor': pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].sePattern === 'pure_color' ? pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].fontSeColor : '',
                      webkitTextFillColor: pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].sePattern === 'linear_gradient' ? 'transparent' : '',
                      '--level_1_bgImage': pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].sePattern === 'linear_gradient' ? `linear-gradient(${pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].seLinear_gradient.deg}deg,${pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].seLinear_gradient.start_color} ${pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].seLinear_gradient.start_pointer}%,${pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].seLinear_gradient.end_color}${pc_widgets_infor.navfont[pc_widgets_infor.navfont.radio_val].seLinear_gradient.end_pointer}%)`: ''
                    }]"
                  @click.stop="toPage(item, pc_widgets_infor.navClick)"
                >
                  {{ item.name }}
                </a>
                <i class="showChildIcon iconfont icon--arrow-right"
                   :class="
                    showList[index] == true
                      ? 'iconDown'
                      : ''
                  "
                   @click.stop="changeChildShow(index)"
                   v-if="item.children && item.children.length != 0"
                ></i>
              </div>
              <ul
                class="sub_nav_list"
                :class="{ showNavList: showList[index] == true }"
              >
                <li class="childnavLi" v-for="(e, i) in item.children" :key="i" :style="[{
                  '--level_2_bgckgroundColor':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type === 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].color : 'transparent',
                  '--level_2_backgroundImage':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].img ? `url(${pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].img})` : 'none',
                  '--level_2_backgroundSize':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_size : 'unset',
                  '--level_2_backgroundRepeat':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_repeat : 'unset',
                  '--level_2_backgroundPosition': pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_position : 'unset'
                  },level_2_background]">
                  <div class="childnavPage">
                    <a class="childnavPageLink" :style="[fontStyleNew_level_2,{
                      '--level_2_SeColor': pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].sePattern === 'pure_color' ? pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].fontSeColor : '',
                      webkitTextFillColor: pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].sePattern === 'linear_gradient' ? 'transparent' : '',
                      '--level_2_bgImage': pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].sePattern === 'linear_gradient' ? `linear-gradient(${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.deg}deg,${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.start_color} ${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.start_pointer}%,${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.end_color}${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.end_pointer}%)`: ''
                      }]" @click.stop="toPage(e)">{{ e.name }}</a>
                      <i
                      class="showChildIcon iconfont icon--arrow-right"
                      :class="showSonList[i] == true ? 'iconDown' : ''"
                      v-if="e.children && e.children.length !== 0"
                        @click.stop="changeSonShow(i)"
                      ></i>
                    </div>
                      <ul
                          class="son_nav_list"
                          :class="{ showNavList: showSonList[i] == true }"
                        >
                          <li
                            class="sonnavLi"
                            v-for="(son, sonIndex) in e.children"
                            :key="sonIndex"
                            :style="[{
                              '--level_2_bgckgroundColor':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type === 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].color : 'transparent',
                              '--level_2_backgroundImage':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].img ? `url(${pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].img})` : 'none',
                              '--level_2_backgroundSize':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_size : 'unset',
                              '--level_2_backgroundRepeat':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_repeat : 'unset',
                              '--level_2_backgroundPosition': pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_position : 'unset'
                              },level_2_background]"
                          >
                            <div class="sonnavPage">
                              <a class="sonnavPageLink"
                              :style="[fontStyleNew_level_2,{
                              '--level_2_SeColor': pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].sePattern === 'pure_color' ? pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].fontSeColor : '',
                              webkitTextFillColor: pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].sePattern === 'linear_gradient' ? 'transparent' : '',
                              '--level_2_bgImage': pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].sePattern === 'linear_gradient' ? `linear-gradient(${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.deg}deg,${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.start_color} ${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.start_pointer}%,${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.end_color}${pc_widgets_infor.navChildfont[pc_widgets_infor.navChildfont.radio_val].seLinear_gradient.end_pointer}%)`: ''
                              }]"
                              @click.stop="toPage(son)">{{
                                son.name
                              }}</a>
                            </div>
                          </li>
                        </ul>
                  </li>
                </ul>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="childrenData childContent"
        :class="pc_widgets_infor.childStyleType"
        v-if="pc_widgets_infor.childStyleType !== 'type_4'"
      >
        <div
          v-for="(item, index) in listData"
          :key="index"
          v-show="activeIndex == index"
          @mouseenter="changeData(activeIndex, childData)"
          @mouseleave="childHoverLeave(false, -1, -1)"
          class="navchildlist"
          :style="{
            top: fixedTop + 'px',
            left:
              pc_widgets_infor.childStyleType == 'type_0'
                ? fixedLeft + 'px'
                : 0,
          }"
        >
          <div class="contentLink"></div>
          <ul
            class="navchildPart"
            v-if="pc_widgets_infor.childStyleType == 'type_0'"
          >
            <li
              class="navchildLine"
              v-for="(e, i) in item.children"
              :key="i"
              @mouseenter="
                (e) => {
                  hoverChild(e, i);
                }
              "
              @click.stop="toPage(e)"
              :style="{
                cursor: 'pointer',
              }"
            >
              <div
                class="navchildData"
                :style="[
                  {
                    textAlign: pc_widgets_infor.navChildtextAlign,
                  },
                  childActiveIndex == i ? ch_Sebackground : ch_background,
                ]"
              >
                <span
                  class="navchildLink"
                  :style="[
                    {
                      textAlign: pc_widgets_infor.navChildtextAlign,
                    },
                    childActiveIndex == i ? ch_SefontStyle : ch_fontStyle,
                  ]"
                >
                  {{ e.name }}
                </span>
              </div>
              <div class="navsonPart" 
              v-show="e.children && e.children.length > 0 && childActiveIndex == i">
                <ul
                  style="width: auto"
                  @mouseleave="
                    activeIndex = -1;
                    childActiveIndex = -1;
                    sonActiveIndex = -1;
                  "
                  :style="{
                    top: fixed3Top + 'px',
                  }"
                >
                  <li
                    class="navchildLine"
                    v-for="(item2, index2) in e.children"
                    :key="index2"
                  >
                    <div
                      class="navchildData"
                      @mouseenter="childHoverLeave(true, index, index2)"
                      @mouseleave="sonActiveIndex = -1"
                      :style="[
                        {
                          textAlign: pc_widgets_infor.navChildtextAlign,
                        },
                        sonActiveIndex == index2
                          ? ch_Sebackground
                          : ch_background,
                      ]"
                    >
                      <span
                        @click.stop="toPage(item2)"
                        class="navchildLink"
                        :style="[
                          {
                            textAlign: pc_widgets_infor.navChildtextAlign,
                          },
                          sonActiveIndex == index2
                            ? ch2_SefontStyle
                            : ch2_fontStyle,
                        ]"
                      >
                        {{ item2.name }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div
            class="child_warp"
            :class="pc_widgets_infor.childStyleType + '_child_warp'"
            v-show="
              (pc_widgets_infor.childStyleType == 'type_1'
              || pc_widgets_infor.childStyleType == 'type_2' ) &&
              item.children &&
              item.children.length > 0
            "
          >
            <div
              class="child_content"
              v-if="
                pc_widgets_infor.childStyleType == 'type_1' ||
                pc_widgets_infor.childStyleType == 'type_2'
              "
            >
              <div
                v-for="(item1, index1) in item.children"
                :key="index1"
                class="child_list"
              >
                <div
                  class="child_content_list"
                  @mouseleave="childActiveIndex = -1"
                  @mouseenter="childActiveIndex = index1"
                >
                  <div
                    class="level_2_content"
                    :style="[
                      childActiveIndex == index1
                        ? ch_Sebackground
                        : ch_background,
                        {
                          textAlign: pc_widgets_infor.navChildtextAlign
                        }
                    ]"
                  >
                    <span
                      class="level_2_title"
                      @click.stop="toPage(item1)"
                      :style="[
                        childActiveIndex == index1
                          ? ch_SefontStyle
                          : ch_fontStyle,
                      ]"
                    >{{ item1.name }}</span
                    >
                  </div>
                  <img
                    v-if="pc_widgets_infor.childStyleType == 'type_2'"
                    :src="
                      item1.icon == null || item1.icon == ''
                        ? 'https://sitecdn.71360.com/static/txys-001/image/noimage.jpg'
                        : item1.icon
                    "
                    class="level_2_icon"
                    @click.stop="toPage(item1)"
                  />
                </div>
                <template v-if="pc_widgets_infor.childStyleType !== 'type_2'">
                  <div
                    v-for="(item2, index2) in item1.children"
                    :key="index2"
                    @mouseenter="sonActiveIndex = item2.id"
                    @mouseleave="sonActiveIndex = -1"
                    :style="[
                      {
                        cursor: 'pointer',
                        textAlign: pc_widgets_infor.navChildtextAlign,
                      },
                      sonActiveIndex == item2.id
                        ? ch_Sebackground
                        : ch_background,
                    ]"
                    class="level_3_content"
                  >
                    <span
                      class="level_3_title"
                      @click.stop="toPage(item2)"
                      :style="[
                        {
                          textAlign: pc_widgets_infor.navChildtextAlign,
                        },
                        sonActiveIndex == item2.id
                          ? ch2_SefontStyle
                          : ch2_fontStyle,
                      ]"
                    >{{ item2.name }}</span
                    >
                  </div>
                </template>
              </div>
            </div>
            <div class="child_content" v-else>
              <div
                v-for="(item1, index1) in item.children"
                :key="index1"
                class="child1_content"
              >
                <div
                  class="child1_content_list"
                  @mouseleave="childActiveIndex = -1"
                  @mouseenter="childActiveIndex = index1"
                  :style="[
                    {
                      textAlign: pc_widgets_infor.navChildtextAlign,
                    },
                    childActiveIndex == index1
                      ? ch_Sebackground
                      : ch_background,
                  ]"
                >
                  <img
                    :src="
                      item1.icon == null || item1.icon == ''
                        ? 'https://sitecdn.71360.com/static/txys-001/image/noimage.jpg'
                        : item1.icon
                    "
                  />
                  <span
                    @click.stop="toPage(item1)"
                    :style="[
                      {
                        textAlign: pc_widgets_infor.navChildtextAlign,
                      },
                      childActiveIndex == index1
                        ? ch_SefontStyle
                        : ch_fontStyle,
                    ]"
                  >{{ item1.name }}</span
                  >
                </div>
                <p class="line" style="margin-left: 10px"></p>
                <div class="child2_content" v-if="item1.children">
                  <span
                    v-for="(item2, index2) in item1.children"
                    :key="index2"
                    @mouseenter="sonActiveIndex = index2"
                    @mouseleave="sonActiveIndex = -1"
                    @click.stop="toPage(item2)"
                    class="child2_content_list"
                    :style="[
                      {
                        textAlign: pc_widgets_infor.navChildtextAlign,
                      },
                      sonActiveIndex == index2
                        ? ch2_SefontStyle
                        : ch2_fontStyle,
                      sonActiveIndex == index2
                        ? ch_Sebackground
                        : ch_background,
                    ]"
                  >{{ item2.name }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <my-navbar v-if="contentPop" :showTag.sync="contentPop"></my-navbar>
     <navbar_dialog v-if="pc_widgets_infor.childStyleType == 'type_4' && navbarDialogShow"
     :activeIndex="activeIndex"
     :listData="listData"
     :pc_widgets_infor="pc_widgets_infor"
     :style="{
        top: navbarFixedTop + 'px'
      }">
     </navbar_dialog>
    <!-- <el-button @click="createNewlist">测定分组</el-button> -->
  </div>
  <div v-else class="mobilePart">
    <ul class="contentPart">
      <li
        class="contentPartLi"
        v-for="(item, index) in listData"
        :key="index"
        v-if="item.module !== 'anchor' || $store.state.app.language === 'zh-cn'"
      >
        <div class="navPage">
          <i
            class="showChildIcon"
            :class="
              showList[index] == true
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-right'
            "
            @click.stop="changeChildShow(index)"
            v-if="item.children && item.children.length != 0"
          ></i>
          <a
            class="navPageLink"
            :style="{
              color:
                routePath === '/' + item.theme_name
                  ? $store.state.myRender.common.theme_color
                  : '#333',
            }"
            @click.stop="toPage(item, pc_widgets_infor.navClick)"
          >
            {{
              item.name
            }}<span
            style="font-size: 12px"
            v-if="
                item.type !== 'Logoimg' &&
                pc_widgets_infor.bilingualSet.radio_val == 'custom' &&
                item.other_name &&
                item.other_name !== '' &&
                item.other_name !== null
              "
          ><i style="padding: 0 5px">|</i>{{ item.other_name }}</span
          >
          </a>
          <ul
            class="sub_nav_list"
            :class="{ showNavList: showList[index] == true }"
          >
            <li class="childnavLi" v-for="(e, i) in item.children" :key="i">
              <div class="childnavPage">
                <i
                  class="showChildIcon"
                  :class="
                    showSonList[i] == true
                      ? 'el-icon-arrow-down'
                      : 'el-icon-arrow-right'
                  "
                  v-if="e.children && e.children.length !== 0"
                  @click.stop="changeSonShow(i)"
                ></i>
                <a class="childnavPageLink" @click.stop="toPage(e)">{{ e.name }}</a>
                <ul
                  class="son_nav_list"
                  :class="{ showNavList: showSonList[i] == true }"
                >
                  <li
                    class="sonnavLi"
                    v-for="(son, sonIndex) in e.children"
                    :key="sonIndex"
                  >
                    <div class="sonnavPage">
                      <a class="sonnavPageLink" @click.stop="toPage(son)">{{
                          son.name
                        }}</a>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import i18n from '../../language/index'

import myNavbar from '@/components/my_navbar/index.vue';
import navbar_dialog from './components/navbar_dialog.vue';
import { basic_navbar_new_style } from "@/base/widgets_data_compatible";
import {
  navList
} from '@/api/app.js';

export default {
  name: 'basic_navbar',
  data() {
    return {
      pcLogoWidth: 0,
      pcLogoHeight: 0,
      leftChangeMax: 0,
      leftChange: 0,
      fixedTop: 0,
      fixed3Top: 0,
      childActiveIndex: null,
      contentWidth: '',
      countPage: 1,
      countMax: 1,
      contentPop: false,
      childData: [],
      activeIndex: -1,
      baseData: [],
      showList: [],
      showSonList: [],
      dataList: {},
      logoIndex: 0,
      swiperOption: {
        slidesPerGroup: 5,
        slidesPerView: 5,
        spaceBetween: 30,
        navigation: {
          nextEl: '.rightBtn',
          prevEl: '.leftBtn'
        }
      },
      listData: [],
      rightListData: [],
      timer: null,
      sonActiveIndex: null,
      moduleStyle: 2,
      dropDownMenuShow: false,
      navbarFixedTop: 0,
      navbarDialogShow: false
    };
  },
  computed: {
    // fixedTop(){
    //   let height = ($(`#u${this.module.widgets_id}`).find('.itemNav').length!=0?$(`#u${this.module.widgets_id}`).find('.itemNav').eq(this.activeIndex).offset().top:0) -1
    //   return height
    // },
    routePath() {
      return this.$route.path;
    },
    fixedLeft() {
      // 这代码真恶心，有个报错，懒得改 ┭┮﹏┭┮
      try {
        let left = this.pc_widgets_infor.childStyleType && this.pc_widgets_infor.childStyleType !== 'type_0' ?
          -$(`#u${this.module.widgets_id}`)
            .find('.basic_navbar').offset().left + 4 :
          (($(`#u${this.module.widgets_id}`).find('.itemNav').length !=
            0 ?
            $(`#u${this.module.widgets_id}`)
              .find('.navContent.hasContent .itemNav')
              .eq(this.activeIndex)
              .position().left + 4 :
            0) +
            $(`#u${this.module.widgets_id}`)
              .find('.hasWidth').position().left +
            parseInt($('.hasContent .navPart').css("marginLeft").replace('px', '')) +
            this.pc_widgets_infor.marginRight[this.pc_widgets_infor.marginRight.radio_val].value * 0 -
            ($(`#u${this.module.widgets_id}`)
                .find('.hiddenContent .navchildPart')
                .eq(this.activeIndex)
                .width() -
              $(`#u${this.module.widgets_id}`)
                .find('.pageLine')
                .eq(this.activeIndex)
                .width() -
              this.pc_widgets_infor.border[this.pc_widgets_infor.border.radio_val].borderWidth * 2) /
            2 +
            this.leftChange) + 4
        return left
      } catch (e) {
        console.error(e)
      }
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    fontStyleNew_level_1() {
      return this.createFontStyleNew(this.pc_widgets_infor.navfont);
    },
    fontStyleNew_level_2() {
      return this.createFontStyleNew(this.pc_widgets_infor.navChildfont);
    },
    level_1_background() {
      let infor = this.pc_widgets_infor.navBackground
      const showType = infor.radio_val;
      const obj = {};
      obj.backgroundColor = 'transparent';
      obj.backgroundImage = 'none';
      obj.backgroundSize = 'unset';
      obj.backgroundRepeat = 'unset';
      obj.backgroundPosition = 'unset';
      if (showType !== 'hidden') {
        const type = infor[infor.radio_val].type;
        if (type === 'color') {
          obj.backgroundColor = infor[infor.radio_val].color;
        } else {
          obj.backgroundColor = infor[infor.radio_val].color;
          obj.backgroundImage = infor[infor.radio_val].img ? 'url(' + infor[infor.radio_val].img + ')' : 'none';
          obj.backgroundSize = infor[infor.radio_val].background_size;
          obj.backgroundRepeat = infor[infor.radio_val].background_repeat;
          obj.backgroundPosition = infor[infor.radio_val].background_position;
        }
      }
      return obj;
    },
    level_2_background() {
      let infor = this.pc_widgets_infor.navChildBackground
      const showType = infor.radio_val;
      const obj = {};
      obj.backgroundColor = 'transparent';
      obj.backgroundImage = 'none';
      obj.backgroundSize = 'unset';
      obj.backgroundRepeat = 'unset';
      obj.backgroundPosition = 'unset';
      if (showType !== 'hidden') {
        const type = infor[infor.radio_val].type;
        if (type === 'color') {
          obj.backgroundColor = infor[infor.radio_val].color;
        } else {
          obj.backgroundColor = infor[infor.radio_val].color;
          obj.backgroundImage = infor[infor.radio_val].img ? 'url(' + infor[infor.radio_val].img + ')' : 'none';
          obj.backgroundSize = infor[infor.radio_val].background_size;
          obj.backgroundRepeat = infor[infor.radio_val].background_repeat;
          obj.backgroundPosition = infor[infor.radio_val].background_position;
        }
      }
      return obj;
    },
    fontStyle() {
      return this.createFontStyle(this.pc_widgets_infor.navfont);
    },
    fontSeStyle() {
      return this.createFontStyle(this.pc_widgets_infor.navfont, 'se');
    },
    ch_fontStyle() {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont);
    },
    ch2_fontStyle() {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont, '', 'ch2');
    },
    ch2_SefontStyle() {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont, 'se', 'ch2');
    },
    ch_SefontStyle() {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont, 'se');
    },
    border() {
      return this.createBorder(this.pc_widgets_infor.border);
    },
    seborder() {
      return this.createBorder(this.pc_widgets_infor.border, 'se');
    },
    base_background() {
      return this.createBackground(this.pc_widgets_infor.navBackground);
    },
    baseSe_background() {
      return this.createBackground(this.pc_widgets_infor.navSeBackground);
    },
    ch_background() {
      return this.createBackground(this.pc_widgets_infor.navChildBackground);
    },
    ch_Sebackground() {
      return this.createBackground(this.pc_widgets_infor.navChildSeBackground);
    }
  },
  components: {
    myNavbar,
    navbar_dialog
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    },
    isInMobileHeader:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    'pc_widgets_infor.styleType'(val) {
      this.dropDownMenuShow = false
    },
    'module.data.listArr': {
      handler: function (val) {
        this.$nextTick(() => {
          this.getImgWidth()
        });
      },
      deep: true
    },
    'module.data.pc_infor': {
      handler: function (val) {
        this.$nextTick(() => {
          let widthPageLine = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].width;
          let width = $(`#u${this.module.widgets_id}`)
            .find('.navContent.hasContent .hasWidth').width();
          // if (this.pc_widgets_infor.showLogo === 'true') {
          //   let logoWidth = $(`#u${this.module.widgets_id}`)
          //     .find('.itemNav.noBorderRa')
          //     .width();
          //   width = (widthPageLine + this.pc_widgets_infor.marginRight[this.pc_widgets_infor.marginRight.radio_val].value + 1) * (this.listData.length - 1) + logoWidth;
          // } else {
          //   width = (widthPageLine + this.pc_widgets_infor.marginRight[this.pc_widgets_infor.marginRight.radio_val].value + 1) * this.listData.length;
          // }
          $('.navLine').css({
            left: 0
          });
          let contentWidth = $('.navContent.hasContent .navPart').width();
          let testWidth = $('.basic_navbar').width();
          // debugger
          this.leftChange = 0;
          this.leftChangeMax = width < contentWidth ? 0 : -width + contentWidth;
          if (this.pc_widgets_infor.showLogo === 'true') {
            this.createNewlist(0);
          }
        });
      },
      deep: true
    },
    pc_widgets_infor: {
      handler: function (val) {
        this.$nextTick(() => {
          let widthPageLine = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].width;
          let width = $(`#u${this.module.widgets_id}`)
            .find('.navContent.hasContent .navLine').width();
          $('.navLine').css({
            left: 0
          });
          let contentWidth = $('.navContent.hasContent .navPart').width();
          let testWidth = $('.basic_navbar').width();
          // debugger
          this.leftChange = 0;
          this.leftChangeMax = width < contentWidth ? 0 : -width + contentWidth;
          if (this.pc_widgets_infor.showLogo === 'true') {
            this.createNewlist(0);
          }
          if (this.pc_widgets_infor.styleType === 'type_5' || this.pc_widgets_infor.styleType === 'type_6' ||
            this.pc_widgets_infor.styleType === 'type_11' || this.pc_widgets_infor.styleType === 'type_12') {
            this.pc_widgets_infor.marginRight.radio_val = 'default'
          }
        });
      },
      deep: true
    },
    activeIndex(val) {
      let navHeight = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].height;
      $(`#u${this.module.widgets_id}`)
        .find('.navPart')
        .css('height', navHeight);
      this.childActiveIndex = -1;
      let top =
        $(`#u${this.module.widgets_id}`).find('.itemNav').length != 0 ?
          $(`#u${this.module.widgets_id}`)
            .find('.navContent.hasContent .itemNav')
            .eq(this.activeIndex)
            .offset().top +
          $(`#u${this.module.widgets_id}`)
            .find('.navContent.hasContent .itemNav')
            .height() :
          0;
      if ($('.pc_pattern').find('.layout_header_fixed').length === 1) {
        top = document.getElementById(`u${this.module.widgets_id}`).getBoundingClientRect().top + $(
          `#u${this.module.widgets_id}`).height();
      }
      this.fixedTop = top;
      this.navbarFixedTop = top
      this.fixedTop =
        $(`#u${this.module.widgets_id}`)
          .find('.navContent.hasContent .itemNav')
          .height() +
        $(`#u${this.module.widgets_id}`)
          .find('.navContent.hasContent .itemNav .contentLink')
          .height() - 1;
      let height = $(`#u${this.module.widgets_id}`)
        .find('.navPart')
        .height();
      $(`#u${this.module.widgets_id}`)
        .find('.navContent.hasContent .itemNav')
        .eq(this.activeIndex)
        .children('.navchildlist')
        .css('height', 'auto')
        .show();
      let childrenHeight = $(`#u${this.module.widgets_id}`)
        .find('.navContent.hasContent .itemNav')
        .eq(this.activeIndex)
        .find('.navchildlist .navchildPart')
        .height() ?
        $(`#u${this.module.widgets_id}`)
          .find('.navContent.hasContent .itemNav')
          .eq(this.activeIndex)
          .find('.navchildlist .navchildPart')
          .height() +
        $(`#u${this.module.widgets_id}`)
          .find('.navContent.hasContent .itemNav .contentLink')
          .height() +
        6 :
        0;
      $(`#u${this.module.widgets_id}`)
        .find('.navPart')
        .css('height', height + childrenHeight);
    },
    contentWidth(val) {
    },
    'pc_widgets_infor.showLogo'(val) {
      this.dropDownMenuShow = false
      if (val === 'true') {
        this.createNewlist(this.leftChange);
      } else {
        if (this.listData[this.logoIndex].type === 'Logoimg') {
          this.listData.splice(this.logoIndex, 1);
          this.logoIndex = 0;
          let widthPageLine = $('.pageLine').eq(0) ? $('.pageLine').eq(0).offsetWidth : 0;
          let width =
            (widthPageLine + this.pc_widgets_infor.marginRight[this.pc_widgets_infor.marginRight.radio_val].value + (
              this.pc_widgets_infor.showLine === 'true' ? $('.navContent.hasContent .line').eq(0).offsetWidth : 0)) *
            this.listData.length;
          // $('.navLine').css({ width: width });
        }
      }
    },
    'module.data.listArr.logoUrl'(val) {
      this.getImgWidth(this.createNewlist(this.leftChange));
    }
  },
  methods: {
    // 打开下拉菜单
    openDropDownMenu() {
      this.dropDownMenuShow = !this.dropDownMenuShow
    },
    hoverChild(e, i) {
      this.childActiveIndex = i
      this.fixed3Top = $(e.target).children('.navchildData').height() * i
    },
    resetTime() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = null
    },
    childHoverLeave(isShow, parentIndex, sonIndex) {
      if (!isShow) {
        if (this.timer == null) {
          this.timer = setTimeout(() => {
            this.resetTime()
            this.activeIndex = -1
            this.childActiveIndex = -1
            this.sonActiveIndex = -1
          }, 300);
        }
      } else {
        this.resetTime()
        this.activeIndex = parentIndex
        this.sonActiveIndex = sonIndex
      }
    },
    getImgWidth(fn) {
      let pcHeight = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].height;
      let imgHeight = $('#baseImg').height();
      let imgWidth = $('#baseImg').width();
      let nowPcHeight = imgHeight * (pcHeight / imgHeight);
      let nowPcWidth = imgWidth * (pcHeight / imgHeight);
      this.pcLogoWidth = nowPcWidth > imgWidth ? imgWidth : nowPcWidth;
      this.pcLogoHeight = nowPcHeight;
      this.module.data.pc_widgets_infor.pcLogoHeight = this.pcLogoHeight;
      this.module.data.pc_widgets_infor.pcLogoWidth = this.pcLogoWidth;
      if (typeof fn === 'function') {
        fn();
      }
    },
    createFontStyleNew(infor, type = "") {
      let obj = {};
      let pattern = '';
      let linear_gradient = {};
      if (type === 'se') {
        pattern = infor[infor.radio_val].sePattern;
        linear_gradient = infor[infor.radio_val].seLinear_gradient;
        obj.color = pattern === 'pure_color' ? infor[infor.radio_val].fontSeColor : '';
      } else {
        pattern = infor[infor.radio_val].pattern;
        linear_gradient = infor[infor.radio_val].linear_gradient;
        obj.color = pattern === 'pure_color' ? infor[infor.radio_val].fontColor : '';
      }
      obj.webkitTextFillColor = pattern === 'linear_gradient' ? 'transparent' : '';
      if (pattern === 'linear_gradient') {
        obj.backgroundImage =
          'linear-gradient(' +
          linear_gradient.deg +
          'deg,' +
          linear_gradient.start_color +
          linear_gradient.start_pointer +
          '%,' +
          linear_gradient.end_color +
          linear_gradient.end_pointer +
          '%)';
          obj['-webkitBackgroundClip'] = 'text'
      } else {
        obj.backgroundImage = '';
      }
      return obj;
    },
    createFontStyle(infor, type = "", levelType = "") {
      const obj = {};
      if (levelType == 'ch2') {
        obj.fontSize = parseInt(infor[infor.radio_val].fontSize) - 2 + 'px';
      } else {
        obj.fontSize = infor[infor.radio_val].fontSize + 'px';
      }
      obj.fontFamily = infor[infor.radio_val].fontFamily;
      obj.fontWeight = infor[infor.radio_val].fontWidth;
      obj.fontStyle = infor[infor.radio_val].fsItalics;

      obj.textDecoration = infor[infor.radio_val].fontUnderline;
      let pattern = '';
      let linear_gradient = {};
      if (type === 'se') {
        pattern = infor[infor.radio_val].sePattern;
        linear_gradient = infor[infor.radio_val].seLinear_gradient;
        obj.color = pattern === 'pure_color' ? infor[infor.radio_val].fontSeColor : '';
      } else {
        pattern = infor[infor.radio_val].pattern;
        linear_gradient = infor[infor.radio_val].linear_gradient;
        obj.color = pattern === 'pure_color' ? infor[infor.radio_val].fontColor : '';
      }
      obj.webkitTextFillColor = pattern === 'linear_gradient' ? 'transparent' : '';
      if (pattern === 'linear_gradient') {
        obj.backgroundImage =
          'linear-gradient(' +
          linear_gradient.deg +
          'deg,' +
          linear_gradient.start_color +
          linear_gradient.start_pointer +
          '%,' +
          linear_gradient.end_color +
          linear_gradient.end_pointer +
          '%)';
          obj['-webkitBackgroundClip'] = 'text'
      } else {
        obj.backgroundImage = '';
      }
      return obj;
    },
    createBorder(infor, type) {
      const obj = {};
      let checkList = infor[infor.radio_val].checkList;
      obj.borderBottomStyle = checkList.indexOf('borderBottomWidth') == -1 ? 'none' : infor[infor.radio_val].borderStyle;
      obj.borderTopStyle = checkList.indexOf('borderTopWidth') == -1 ? 'none' : infor[infor.radio_val].borderStyle;
      obj.borderRightStyle = checkList.indexOf('borderRightWidth') == -1 ? 'none' : infor[infor.radio_val].borderStyle;
      obj.borderLeftStyle = checkList.indexOf('borderLeftWidth') == -1 ? 'none' : infor[infor.radio_val].borderStyle;
      obj.borderColor = type === 'se' ? infor[infor.radio_val].borderSeColor : infor[infor.radio_val].borderColor;
      obj.borderWidth = infor[infor.radio_val].borderWidth + 'px';
      return obj;
    },
    createBackground(infor) {
      const showType = infor.radio_val;
      const obj = {};
      obj.backgroundColor = 'transparent';
      obj.backgroundImage = 'none';
      obj.backgroundSize = 'unset';
      obj.backgroundRepeat = 'unset';
      obj.backgroundPosition = 'unset';
      if (showType !== 'hidden') {
        const type = infor[infor.radio_val].type;
        if (type === 'color') {
          obj.backgroundColor = infor[infor.radio_val].color;
        } else {
          obj.backgroundColor = infor[infor.radio_val].color;
          obj.backgroundImage = infor[infor.radio_val].img ? 'url(' + infor[infor.radio_val].img + ')' : 'none';
          obj.backgroundSize = infor[infor.radio_val].background_size;
          obj.backgroundRepeat = infor[infor.radio_val].background_repeat;
          obj.backgroundPosition = infor[infor.radio_val].background_position;
        }
      }
      return obj;
    },
    toPage(item, type = 'true') {
      if (this.$store.state.app.view_pattern === 'mb'||$('.mobile_header .navPart').hasClass('active')) {
        $('.mobile_header .navPart').removeClass('active');
        $('.mobile_header .menuPart').removeClass('activeIcon');
      }
      if (type === 'false' && item.children.length > 0) {
        return false;
      }
      // if (this.$route.path === '/' + item.theme_name) {
      //   return false;
      // }
      if (item.type === 'Logoimg') {
        return false;
      }
      let that = this;
      if (this.$store.state.app.is_change) {
        if (item.module === 'anchor') {
          let link = item.theme_name.split('#');
          let anchorType = 'other_page';
          if (link[0] == '/') link[0] = 'index:index';
          let id = link[1];
          let path = '';
          let urlList = this.$store.state.app.websiteSection;
          urlList.map(e => {
            if (e.module == link[0]) {
              path = e.routerPath;
            }
            if (e.routerPath === this.$store.state.app.now_page && e.module == link[0]) {
              anchorType = 'cur_page';
            }
          });
          if (!path) {
            this.$message.warning({
              showClose: true,
              message: i18n.t('base_row_jcp_1921')
            });
            return false;
          }
          if (anchorType === 'cur_page') {
            this.templet.active_anchor(anchorType, id, path);
            return false;
          }
        }
        this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          center: true,
          // customClass: 'del_dialog',
          appendToBody: true
        })
          .then(() => {
            this.templet.toPage(item);
          })
          .catch(() => {
          });
      } else {
        this.templet.toPage(item);
      }
    },
    showContentPopfn() {
      this.contentPop = true;
    },
    showContentPop() {
      if (this.$store.state.app.is_change) {
        this.$confirm(i18n.t('components_my_anchor_set_index_2235'), '', {
          confirmButtonText: i18n.t('components_my_anchor_set_index_2236'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        })
          .then(() => {
            this.templet.p_save(this.showContentPopfn());
          })
          .catch(() => {
          });
      } else {
        this.showContentPopfn();
      }
    },
    changeChildShow(i) {
      let type = this.showList.length == 0 ? true : !this.showList[i];
      this.showList = [];
      this.showList[i] = type;
      this.showSonList = [];
    },
    changeSonShow(i) {
      let type = this.showSonList.length == 0 ? true : !this.showSonList[i];
      this.showSonList = [];
      this.showSonList[i] = type;
    },
    stayHover() {
      // this.childActiveIndex = null;
      // $('.navchildlist').hide();
      this.activeIndex = null;
      // this.childData = [];
    },
    getRightNavData() {
      let contentWidth = $('.navContent.hasContent .navPart').width();
      let width = $(`#u${this.module.widgets_id}`).find('.navContent.hasContent .navLine').width();
      this.leftChange = 0;
      this.leftChangeMax = width < contentWidth ? 0 : -width + contentWidth;
      let domList = $(`#u${this.module.widgets_id}`).find('.navContent.hasContent .hasWidth .itemNav')
      let navItemWidth = 0
      let index = -1
      for (let i = 0; i < domList.length; i++) {
        navItemWidth = navItemWidth + $(domList[i]).width()
        if (Math.abs(navItemWidth - contentWidth) <= $(domList[i]).width() * 0.6) {
          index = i
          break
        }
      }
      index = index + 1 > this.listData.length - 1 ? index : index + 1
      this.rightListData = this.listData.slice(index, this.listData.length)
      if (this.rightListData.length == this.listData.length || $(`#u${this.module.widgets_id}`).find('.btn_part .rightBtn').css('display') == 'none') {
        $(`#u${this.module.widgets_id}`).find('.navbar_dropdown_panel').css({
          display: 'none'
        })
        return false
      }
    },
    getNavList() {
      let that = this;
      navList({
        withlevel: 1
      })
        .then(res => {
          if (res.code == 200) {
            let data = res.data;
            for (let i = 0; i < data.length; i++) {
              if (!data[i].children) {
                data[i].children = [];
              }
            }
            that.baseData = data;
            let logoData = {
              type: 'Logoimg'
            };
            that.listData = data.filter(e => {
              if (e.children) {
                e.children = e.children.filter(i => {
                if (i.children) {
                    i.children = i.children.filter(j => {
                      return j.disabled != 'true' && j.show_in_nav != 'false';
                    });
                  }
                  return i.disabled != 'true' && i.show_in_nav != 'false';
                });
              }
              return e.disabled != 'true' && e.show_in_nav != 'false';
            });
            if (that.pc_widgets_infor.showLogo === 'true') {
              that.logoIndex = that.listData.length;
              that.listData.push(logoData);
            }
            that.$store.commit('app/set_navListData', data);
            if (that.$store.state.app.view_pattern === 'pc') {
              that.$nextTick(()=> {
                let listWidth = $(`#u${that.module.widgets_id}`)
                  .find('.navContent.hasContent  .navLine')
                  .width();
                  if(listWidth == 0 || listWidth == null) {
                    setTimeout(() => {
                      listWidth = $(`#u${that.module.widgets_id}`)
                  .find('.navContent.hasContent  .navLine')
                  .width();
                      let contentWidth = $('.navContent.hasContent .navPart').width();
                      if (listWidth > contentWidth) {
                        $(`#u${that.module.widgets_id}`)
                          .find('.btn_part .rightBtn')
                          .show();
                      }
                    },1000)
                  }
                let widthPageLine = that.pc_widgets_infor.navheight[that.pc_widgets_infor.navheight.radio_val].width;
                $('.navLine').css({
                  left: 0
                });
                let contentWidth = $('.navContent.hasContent .navPart').width();
                // debugger
                if (that.pc_widgets_infor.showLogo === 'true') {
                  let logoWidth = $(`#u${that.module.widgets_id}`)
                    .find('.itemNav.noBorderRa')
                    .width();
                  if (listWidth > contentWidth) {
                    $(`#u${that.module.widgets_id}`)
                      .find('.btn_part .rightBtn')
                      .show();
                  }
                  that.leftChangeMax = listWidth < contentWidth ? 0 : -listWidth + contentWidth;
                  that.createNewlist(0);
                } else {
                  that.leftChangeMax = listWidth < contentWidth ? 0 : -listWidth + contentWidth;
                  if (that.pc_widgets_infor.styleType == 'type_13') {
                    that.getRightNavData()
                  }
                }
              })
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeState() {
    },
    hoverChange(e, isHover) {
      if(isHover){
        $(e.target).addClass('active')
      }else{
        $(e.target).removeClass('active')
      }
      if (this.pc_widgets_infor.bilingualSet.radio_val == 'custom') {
        if (this.pc_widgets_infor.bilingualSet.custom.type == 1) {
          let nav_name_width = $(e.target).find('.nav_item_name').width()
          let other_name_width = $(e.target).find('.other_name').width()
          let width = nav_name_width > other_name_width ? nav_name_width : other_name_width
          if (isHover) {
            $(e.target).find('.nav_item_name').css({
              width: width + 'px',
              display: 'none'
            })
            $(e.target).find('.other_name').css('display', 'block')
          } else {
            $(e.target).find('.nav_item_name').css({
              width: '100%',
              display: 'block'
            })
            $(e.target).find('.other_name').css('display', 'none')
          }
        } else {
          let move = $(e.target).find('.nav_item_name').eq(0).height()
          let nav_item_name = 0
          let other_name = 0
          if (this.pc_widgets_infor.bilingualSet.custom.type == 0) {
            nav_item_name = move
            other_name = -move
          } else {
            nav_item_name = -move
            other_name = move
          }
          if (isHover) {
            $(e.target).find('.nav_item_name').css('transform', `translateY(${nav_item_name}px)`)
            $(e.target).find('.other_name').css('transform', `translateY(${other_name}px)`)
          } else {
            $(e.target).find('.nav_item_name').css('transform', 'translateY(0)')
            $(e.target).find('.other_name').css('transform', 'translateY(0)')
          }
        }
      }
    },
    changeData(index, list = []) {
      this.childData = [];
      this.childData = list;
      this.activeIndex = index;
      if(index !== -1 && this.pc_widgets_infor.childStyleType == 'type_4') {
        this.navbarDialogShow = this.listData[index] && this.listData[index].children && this.listData[index].children.length > 0 ? true : false
      }
      this.resetTime()
      if (index === -1) {
        let height = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].height;
        $(`#u${this.module.widgets_id}`)
          .find('.navPart')
          .css('height', height);
      }
      if (index + 1 > $('.navContent.hasContent .pageLine').length) {
        return false;
      }
    },
    getNumberIndex() {
      let itemNavList = $(`#u${this.module.widgets_id}`).find('.navContent .itemNav')
      let len = itemNavList.length
      let navWidth = 0
      let logoWidth = $(`#u${this.module.widgets_id}`).find('.itemNav.noBorderRa').width();
      for (let i = 0; i < len; i++) {
        navWidth = navWidth + $(itemNavList[i]).width()
      }
      navWidth = navWidth - logoWidth
      return navWidth / (len - 1)
    },
    changeSize(num) {
      //  contentWidth除以li宽度取floor 然后依据值计算left
      // 右边到底的时候重新计算left值
      let width = $('.navContent.hasContent .navLine').width();
      let liWidth = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].width + this.pc_widgets_infor.marginRight[this.pc_widgets_infor.marginRight.radio_val].value + 1;
      let contentWidth = $('.navContent.hasContent .navPart').width();

      let logoWidth = 0;
      let indexNumber = 0;
      if (this.pc_widgets_infor.showLogo === 'true') {
        logoWidth = $(`#u${this.module.widgets_id}`)
          .find('.itemNav.noBorderRa')
          .width();
        indexNumber = Math.round((contentWidth - logoWidth) / liWidth) == 0 ? 1 : Math.round((contentWidth -
          logoWidth) / liWidth);
      } else {
        indexNumber = Math.round(contentWidth / liWidth) == 0 ? 1 : Math.round(contentWidth / liWidth);
      }
      console.log('indexNumber:', indexNumber)
      let leftValue = $('.navContent.hasContent .navLine').position().left;
      let leftChange = 0;
      if (leftValue + num == 1 || leftValue * num == -width || width - contentWidth - leftValue * num === 0) {
        if (num === 1) {
          $('.btn_part .leftBtn').hide();
        } else {
          $('.btn_part .rightBtn').hide();
        }
        return false;
      } else if (contentWidth > width - leftValue * num - indexNumber * liWidth) {
        leftChange = num * (width - contentWidth) + leftValue;
      } else if (contentWidth > -1 * leftValue && num == 1) {
        leftChange = 0;
      } else {
        leftChange = num * indexNumber * liWidth + leftValue;
      }
      if (leftChange >= width - contentWidth) {
        leftChange = width - contentWidth;
        if (leftChange < 0) {
          leftChange = 0;
          if (width > contentWidth) {
            $('.btn_part .rightBtn').show();
          }
        }
      } else if (leftChange <= -width + contentWidth) {
        leftChange = -width + contentWidth;
      }
      if (leftChange > 0) {
        leftChange = 0;
        if (width > contentWidth) {
          $('.btn_part .rightBtn').show();
        }
      }
      this.leftChange = leftChange;
      $('.navContent.hasContent .navLine').css({
        left: leftChange
      });
      if (this.pc_widgets_infor.showLogo === 'true') {
        this.createNewlist(leftChange);
      }
    },
    createNewlist(leftValue) {
      let liWidth = this.pc_widgets_infor.navheight[this.pc_widgets_infor.navheight.radio_val].width + this.pc_widgets_infor.marginRight[this.pc_widgets_infor.marginRight.radio_val].value + 1;
      let leftCount = Math.abs(leftValue / liWidth);
      let logoWidth = $(`#u${this.module.widgets_id}`)
        .find('.itemNav.noBorderRa')
        .width();
      let width = $('.navContent.hasContent .navPart').width() - logoWidth;
      let contentCount = Math.ceil(width / liWidth) + 1 > this.listData.length ? this.listData.length : Math.ceil(
        width / liWidth);
      let logoIndex = 1;
      logoIndex = Math.ceil((contentCount - 1) / 2);
      logoIndex === 0 ? (logoIndex = 1) : logoIndex;
      if (this.listData[this.logoIndex] && this.listData[this.logoIndex].type == 'Logoimg') {
        this.listData.splice(this.logoIndex, 1);
      }
      let data = {
        type: 'Logoimg'
      };
      logoIndex = Math.ceil(logoIndex + leftCount);
      this.listData.splice(logoIndex, 0, data);
      this.logoIndex = logoIndex;
      this.getImgWidth()
    }
  },
  mounted() {
    this.contentWidth = this.$el.clientWidth;
    this.getNavList();
    let _that = this
    $(window).resize(function () {
      _that.timer = setTimeout(() => {
        _that.timer = null
        let listWidth = $(`#u${_that.module.widgets_id}`).find('.navContent.hasContent  .navLine').width();
        let contentWidth = $('.navContent.hasContent .navPart').width();
        if (_that.pc_widgets_infor.showLogo === 'true' && $(`#u${_that.module.widgets_id}`).find('.basic_navbar').length != 0 &&
          _that.$store.state.app.view_pattern === 'pc') {
          if (listWidth > contentWidth) {
            $(`#u${_that.module.widgets_id}`).find('.btn_part .rightBtn').show();
          }
          if (_that.listData[_that.logoIndex] && _that.listData[_that.logoIndex].type === 'Logoimg') {
            _that.listData.splice(_that.logoIndex, 1);
            _that.logoIndex = 0;
          }
          _that.leftChangeMax = listWidth < contentWidth ? 0 : -listWidth + contentWidth;
          _that.createNewlist(this.leftChange);
        } else {
          _that.leftChangeMax = listWidth < contentWidth ? 0 : -listWidth + contentWidth;
          if (_that.pc_widgets_infor.showLogo == 'false' && _that.pc_widgets_infor.styleType == 'type_13') {
            _that.getRightNavData()
          }
        }
      }, 500)
    })
    $(window).scroll(() => {
			if(_that.pc_widgets_infor.childStyleType == 'type_4') {
        _that.navbarDialogShow = false
			}
		})
  },
  created() {
    this.templet.checkMarginRightValue(this.pc_widgets_infor)
    this.templet.checkChildStyleValue(this.pc_widgets_infor)
    if (typeof this.pc_widgets_infor.bilingualSet == "undefined") {
      this.$set(this.pc_widgets_infor, "bilingualSet", basic_navbar_new_style().bilingualSet);
    }
    if(typeof  this.pc_widgets_infor.navTextAlign == 'object' || typeof  this.pc_widgets_infor.navTextAlign == 'undefined'){
      this.$set(this.pc_widgets_infor, "navTextAlign", basic_navbar_new_style().navTextAlign);
    }
    if (typeof this.pc_widgets_infor.showArrow == "undefined") {
      this.$set(this.pc_widgets_infor, "showArrow", 'false');
    }
  }
};
</script>

<style lang="scss" scoped>
.basic_navbar .pageLine:last-child {
  margin-right: 0 !important;
}

.basic_navbar .pageLine {
  display: inline-block;
  padding: 0 8px;
  vertical-align: middle;
  margin-right: 30px;
  border-radius: 4px;
  border-width: 0px;
  border-top-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-right-style: solid;
  text-align: center;
  background-size: 100% 100%;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s,
  -moz-transform 0.4s, -o-transform 0.4s;

  .pagePart {
    height: 100%;
    font-size: 0;
    color: #333;
    border-width: 0px;
    border-top-style: none;
    border-bottom-style: solid;
    border-left-style: none;
    border-right-style: none;
    border-color: transparent;
  }

  span {
    white-space: nowrap;
    box-sizing: border-box;
  }

  .pageLink {
    width: calc(100% - 0px);
    height: 100%;
    cursor: pointer;
    vertical-align: top;
  }

  .pageLink.navNoClick {
    cursor: unset;
  }
}


.basic_navbar .pageLine.active{
    transform-style: preserve-3d;
    background-color: unset !important;
}

.basic_navbar .pageLine::before{
    content:'';
    left: 50%;
    width:0px;
    height: 100%;
    opacity:0;
    position: absolute;
    transform: translateZ(-1px);
    transition: all 0.5s;
    -moz-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
}

.basic_navbar .pageLine.active::before {
    content:'';
    width: 100%;
    height: 100%;
    left: 0%;
    // background-color: {$pc_widgets_infor.navSeBackground[$pc_widgets_infor.navSeBackground.radio_val].color};
    // border-radius:{$pc_widgets_infor.borderRadius[$pc_widgets_infor.borderRadius.radio_val].value}px;    
    background-color: var(--baseSe_background_color);
    border-radius: var(--borderRadius);
    position: absolute;
    z-index: -1;
    opacity: 1;
    transform: translateZ(-1px);
    transition: all 0.5s;
    -moz-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
}

.basic_navbar .line {
  display: inline-block;
  font-size: 14px;
  background-color: #eee;
  width: 1px;
  position: relative;
  vertical-align: middle;
}

.basic_navbar .pagePart:hover {
  .navchildPart {
    display: block;
  }
}

.basic_navbar .btn_part {
  position: relative;

  .leftBtn {
    position: absolute;
    left: 0;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    z-index: 99;
    background-color: inherit;
  }

  .rightBtn {
    position: absolute;
    right: 0;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    z-index: 99;
    background-color: inherit;
  }

  .icon-gengduo1 {
    font-size: 20px;
    font-weight: bold;
  }
}

.basic_navbar .navchildlist {
  // width: 100%;
  // position: relative;
  // z-index: 999;
  // display: none;
  height: 0;
  position: absolute;
  z-index: 1998;
  top: 0px;

  .navchildPart,
  .navsonPart {
    min-width: 160px;
    border-radius: 4px;
    // left: 50%;
    // top:70px;
    // transform: translate(-50%,0);
    // background: #fff;
    border-style: solid;
    border-width: 0;
    color: #333;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);

    .navchildLine {
      min-width: 80px;
      height: 40px;
      line-height: 40px;
      border-width: 0px;
      border-top-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-right-style: solid;
      border: none;

      .navchildData {
        display: block;
        padding: 0 10px;
        height: 100%;

        .navchildLink {
          margin: 0 auto;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}

.basic_navbar .logoPart {
  height: 100%;
  display: block;
}

.basic_navbar .changeImg {
  padding: 0 5px;
  font-size: 13px;
  height: 20px;
  line-height: 20px;
  background: rgba(46, 52, 59, 0.88);
  color: #fff;
  position: absolute;
  right: 30px;
  bottom: 0;
  cursor: pointer;
  display: none;
  z-index: 2;
}

.basic_navbar .itemNav:hover {
  .changeImg {
    display: block;
  }
}

.basic_navbar .navConten .itemNav:last-child .pageLine {
  margin-right: 0 !important;
}

.basic_navbar .navPart {
  // overflow: hidden;
  margin: 0 30px;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.basic_navbar .navLine {
  transition: left 0.4s ease;
  position: relative;
  top: 0;
  font-size: 0;
  text-align: center;
  margin: 0 auto;
  display: table-cell;
  white-space: nowrap;

  .itemNav {
    display: inline-block;
    position: relative;
  }
}

.mobilePart .contentPart {
  display: block;
  padding-top: 1px;
  font-size: 0;
  align-items: center;

  .contentPartLi {
    border: none;
    border-color: #f2f2f2;
    border-top: 1px solid #f2f2f2;
    height: auto;
    font-size: 14px;
    width: auto;
    line-height: 50px;
    text-align: left;
    padding: 0;
    transition: 0.36s ease;
    position: relative;
    min-width: 80px;
    white-space: nowrap;
    cursor: pointer;

    .navPage {
      display: block;
      height: 100%;
      color: inherit;
      line-height: 50px;
      text-align: left;
      position: relative;

      .showChildIcon {
        display: inline;
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        padding: 0 15px;
        box-sizing: border-box;
        height: 50px;
        line-height: inherit;
        transition: all 0.4s;
        color: #666;
        text-align: center;
      }

      .navPageLink {
        padding-left: 26px;
        width: calc(100% - 50px);
        box-sizing: border-box;
        display: block;
        height: 100%;
        color: inherit;
      }

      .sub_nav_list {
        // display: none;
        position: relative;
        opacity: 0;
        height: 0px;
        top: 0;
        left: 0;
        overflow: hidden;
        box-shadow: none;
        min-width: 160px;
        transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s,
        -moz-transform 0.4s, -o-transform 0.4s;

        .childnavLi {
          width: auto;
          min-width: 40px;
          border-style: solid;
          border-width: 0;
          padding: 0 10px;
          height: auto;
          line-height: 50px;
          border-top: 1px solid #f2f2f2;
          position: relative;

          .childnavPageLink {
            padding-left: 48px;
            width: calc(100% - 50px);
            box-sizing: border-box;
            display: block;
            height: 100%;
            color: inherit;
          }
        }
      }

      .sub_nav_list.showNavList {
        height: 100%;
        opacity: 1;
      }

      .son_nav_list {
        // display: none;
        position: relative;
        opacity: 0;
        height: 0px;
        top: 0;
        left: 0;
        overflow: hidden;
        box-shadow: none;
        min-width: 160px;
        transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s,
        -moz-transform 0.4s, -o-transform 0.4s;

        .sonnavLi {
          width: auto;
          min-width: 40px;
          border-style: solid;
          border-width: 0;
          padding: 0 10px;
          height: auto;
          line-height: 50px;
          border-top: 1px solid #f2f2f2;

          .sonnavPageLink {
            padding-left: 70px;
            width: calc(100% - 50px);
            box-sizing: border-box;
            display: block;
            height: 100%;
            color: inherit;
          }
        }
      }

      .son_nav_list.showNavList {
        height: 100%;
        opacity: 1;
      }
    }
  }
}

.basic_navbar:hover {
  .tooptipPart {
    display: block;
  }
}

.basic_navbar .tooptipPart {
  display: none;
  position: absolute;
  // z-index: 100;
  z-index: 5001;
  top: 0;
  right: 0;
  height: 28px;
  line-height: 28px;
  background: rgba(46, 52, 59, 0.88);
  font-size: 0;
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: middle;
  white-space: nowrap;

  .lineControl {
    display: inline-block;
    height: 100%;
    padding: 0 10px;
    font-size: 13px;
    word-break: keep-all;
    cursor: pointer;
    vertical-align: middle;
    text-align: center;
    border-right: 1px solid #595f65;
    color: #fff;
    vertical-align: middle;

    &:hover {
      background-color: #2e343b;
    }
  }

  .lineControl:last-child {
    border: none;
  }
}

.tooptipPart:hover {
  display: block;
}

.hiddenContent {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  z-index: 1;
}

.contentLink {
  height: 0px;
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  z-index: 101;
  position: relative;
}

.pc_pattern .basic_navbar .hasWidth {
  display: inline-block;
}

.basic_navbar .firstImg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  width: auto;
  pointer-events: none;
}

.basic_navbar .childrenData.type_1 .navchildlist {
  width: 100%;

  .navchildPart {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    background-color: #fff;

    .navchildLine {
      min-width: 96px;
      height: 50px;
      line-height: 50px;
    }
  }
}

// 双语设置
.navPart .pageLine .other_name {
  font-size: 14px;
  color: #333;
  display: block;
}

.pageLine .nav_item_name,
.pageLine .other_name {
  transition: transform 0.3s;
}

.pageLine .bilingualSetWarp_1 .nav_item_name,
.pageLine .bilingualSetWarp_1 .other_name {
  transition: opacity 0.3s;
}

.basic_navbar .childrenData.type_0 .navchildlist .navsonPart {
  position: absolute;
  top: 0;
  left: 104%;
  width: auto;
}
.basic_navbar .childrenData.type_0 .navchildlist .navsonPart .navchildLink{
  display: block;
}

.child_warp {
  box-shadow: 0 0 2px #999;
  width: 100%;
  padding: 15px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}

.child_content {
  display: flex;
  flex-wrap: wrap;

  .child1_content {
    width: 100%;
    display: flex;
    margin-bottom: 15px;

    .child1_content_list {
      display: flex;

      img {
        width: 130px;
        height: 130px;
        object-fit: cover;
        margin-right: 10px;
      }

      span {
        display: inline-block;
        margin-right: 10px;
        max-width: calc(100% - 130px);
      }
    }

    .child2_content {
      flex: 1;
      margin-left: 10px;

      .child2_content_list {
        display: inline-block;
        margin-bottom: 20px;
        margin-right: 20px;
        font-size: 14px;
      }
    }
  }

  .child_list {
    width: 210px;
    padding: 0 10px;
    margin-bottom: 20px;

    .level_2_content {
      border-bottom: 1px solid #ebeef5;
      color: #333;
      font-weight: bolder;
      font-size: 16px;
      cursor: pointer;
    }

    .level_2_icon {
      display: block;
      width: 100%;
      height: 100%;
      margin: 10px 0;
      object-fit: cover;
      cursor: pointer;
    }

    .level_3_content {
      margin: 10px;
      text-align: left;
    }
  }
}

.basic_navbar .childrenData.type_2 .navchildlist,
.basic_navbar .childrenData.type_3 .navchildlist {
  width: 100%;
  height: 0;
  position: absolute;
  z-index: 1998;
  top: 0px;
}

.type_1_child_warp .child_content .child_list .level_2_content {
  text-align: center;
}

.type_2_child_warp .child_content .child_list .level_2_content {
  text-align: left;
  padding-left: 15px;
}

.navbar_dropdown_panel {
      top: 50px;
      position: absolute;
      width: 160px;
      background-color: #fff;
      z-index: 9999;
      box-sizing: border-box;
      right: -65px;
      max-height: 300px;
      border-radius: 5px;
      .dropdown_panel_triangle {
          width: 12px;
          height: 12px;
          background: #fff;
          position: absolute;
          left: 50%;
          transform-origin: center center;
          box-sizing: border-box;
          box-shadow: inherit;
          border: 1px solid #ebebeb;
          border-left: 0;
          border-bottom: 0;
          top: 0;
          transform: translate(-50%,-50%) rotate(-45deg);
      }
        .navbar_dropdown_content {
          max-height: 300px;
          overflow-x: hidden;
          overflow-y: auto;
          font-size: 0;
          align-items: center;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          .navbar_dropdown_item {
            height: auto;
            font-size: 14px;
            width: auto;
            padding: 0;
            transition: 0.36s ease;
            position: relative;
            cursor: pointer;
            .navPage {
              display: block;
              height: 100%;
              color: inherit;
              text-align: center;
              position: relative;
              padding: 10px;
              .iconDown {
                transform: rotate(90deg);
              }
              .showChildIcon {
                display: inline;
                position: absolute;
                right: 0;
                top: 10px;
                padding: 0 15px;
                box-sizing: border-box;
                line-height: inherit;
                transition: all 0.4s;
                color: #666;
                text-align: center;
              }
            }
              .navPageLink {
                width: calc(100% - 20px);
                box-sizing: border-box;
                display: block;
                height: 100%;
                color: inherit;
                line-height: normal;
                word-break: normal;
              }
              .sub_nav_list {
                position: relative;
                opacity: 0;
                height: 0px;
                top: 0;
                left: 0;
                overflow: hidden;
                box-shadow: none;
                transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s,
                  -moz-transform 0.4s, -o-transform 0.4s;
                .childnavLi {
                  font-size: 12px;
                  text-align: center;
                  height: auto;
                  width: auto;
                  padding: 0;
                  transition: 0.36s ease;
                  position: relative;
                  cursor: pointer;
                    .childnavPage {
                      display: block;
                      height: 100%;
                      color: inherit;
                      text-align: center;
                      position: relative;
                      padding: 10px;
                    .iconDown {
                      transform: rotate(90deg);
                    }
                    .showChildIcon {
                      display: inline;
                      position: absolute;
                      right: 0;
                      top: 5px;
                      padding: 0 15px;
                      box-sizing: border-box;
                      line-height: inherit;
                      transition: all 0.4s;
                      color: #666;
                      text-align: center;
                    }
                  }
                  .childnavPageLink {
                    padding-left: 35px;
                    text-align: left;
                    width: calc(100% - 20px);
                    box-sizing: border-box;
                    display: block;
                    line-height: normal;
                    height: 100%;
                    color: inherit;
                    word-break: normal;
                  }
                }
              }
              .sub_nav_list.showNavList {
                height: 100%;
                opacity: 1;
              }
              .son_nav_list {
                position: relative;
                opacity: 0;
                height: 0px;
                top: 0;
                left: 0;
                overflow: hidden;
                box-shadow: none;
                min-width: 160px;
                transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s,
                  -moz-transform 0.4s, -o-transform 0.4s;
                .sonnavLi {
                  width: auto;
                  min-width: 40px;
                  border-style: solid;
                  border-width: 0;
                  padding: 0 10px;
                  height: auto;
                  line-height: 40px;
                  .sonnavPage {
                    display: block;
                    height: 100%;
                    color: inherit;
                    text-align: center;
                    position: relative;
                    padding: 10px;
                  }
                  .sonnavPageLink {
                    padding-left: 40px;
                    width: 100%;
                    box-sizing: border-box;
                    display: block;
                    line-height: normal;
                    height: 100%;
                    color: inherit;
                  }
                }
              }
            .son_nav_list.showNavList {
              height: 100%;
              opacity: 1;
            }
          }
        }
    }
  .basic_navbar .navbar_dropdown_panel .navbar_dropdown_item:hover .navPageLink{
    color: var(--level_1_SeColor) !important;
    -webkit-background-clip: text;
    background-image: var(--level_1_bgImage) !important;
  }
  .basic_navbar .navbar_dropdown_panel .navbar_dropdown_item:hover .navPage{
    background-color: var(--level_1_bgckgroundColor) !important;
    background-image: var(--level_1_backgroundImage) !important;
    background-size: var(--level_1_backgroundSize) !important;
    background-repeat: var(--level_1_backgroundRepeat) !important;
    background-position: var(--level_1_backgroundPosition) !important;
  }
  .navbar_dropdown_panel .sub_nav_list .childnavLi:hover .childnavPageLink,
  .navbar_dropdown_panel .son_nav_list .sonnavLi:hover .sonnavPageLink {
    color: var(--level_2_SeColor) !important;
    -webkit-background-clip: text;
    background-image: var(--level_2_bgImage) !important;
  }
  .navbar_dropdown_panel .sub_nav_list .childnavLi:hover,
  .navbar_dropdown_panel .son_nav_list .sonnavLi:hover {
    background-color: var(--level_2_bgckgroundColor) !important;
    background-image: var(--level_2_backgroundImage) !important;
    background-size: var(--level_2_backgroundSize) !important;
    background-repeat: var(--level_2_backgroundRepeat) !important;
    background-position: var(--level_2_backgroundPosition) !important;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/basic_navbar/index.vue